import { Connector, ConnectorImport } from '../common/redux/api/web-api'

const findChargingConnector = (connectors: Connector[]): Connector | undefined => connectors?.find(isChargingConnector)

export const isChargingConnector = (connector: Connector): boolean => connector?.connectorFunctionType === 'Charger'

export const isChargingConnectorImport = (connector: ConnectorImport): boolean => {
    return (
        connector?.name === 'Charger' ||
        connector?.name === 'Left connector' ||
        connector?.name === 'Right connector' ||
        connector?.name === 'Left socket' ||
        connector?.name === 'Right socket' ||
        connector?.name === 'Socket'
    )
}
export default findChargingConnector
